export const CHANGE_SIZE = 'CHANGE_SIZE' //获取window尺寸
